import React from "react";
import Multiselector from "components/multiselector-wrapper";
import { useFetch } from "@/hooks/useFetch";
import { getItemsFromCollection } from "directus/src/operations";
import { EvtSelect } from "components/select";
import { useParams } from "react-router-dom";
import { useJob } from "@/modules/work/jobs/context";
import useCheckPermission from "hooks/src/useCheckPermissons";
import { TooltipInfo } from "components/info-tooltip";
import CalendarDatePicker from "ui/components/comp-507";


const BudgetFilters = ({ filters, setFilters }) => {
  const { jobId } = useParams();
  const { type } = useJob();

  const { canRead } = useCheckPermission({ collection: "billables" });

  // const { data, isLoading, error } = useFetch({
  //   queryKey: ["billables", jobId],
  //   queryFn: async () => {
  //     const query = {
  //       fields: ["id", "name", "billing_date", "invoice_number"],
  //       limit: -1,
  //       sort: ["billing_date"],
  //       filter: {
  //         job: { _eq: jobId },
  //         status: { _in: ["billed", "collected"] },
  //       },
  //     };
  //     const response = await getItemsFromCollection("billables", query);

  //     const data = response.map((billable) => {
  //       const name =
  //         (billable?.name ? `${billable.name} | ` : "") +
  //         (billable?.billing_date ? `${billable.billing_date} ` : "") +
  //         (billable?.invoice_number ? ` | ${billable.invoice_number} ` : "");
  //       return { name, id: billable.id };
  //     });
  //     return data;
  //   },
  //   enabled: canRead,
  // });

  if (!canRead) return null;


  const handleDateRangeChange = (dateRange) => {
    setFilters({
      ...filters,
      startDate: dateRange?.from || undefined,
      endDate: dateRange?.to || undefined,
    });
  };

  const dateRange = {
    from: filters?.startDate,
    to: filters?.endDate,
  };

  return (
    <div className="w-full flex gap-2">
      <CalendarDatePicker
        date={dateRange}
        setDate={handleDateRangeChange}
        placeholder="Pick a date range"
      />
      {/* {type !== "fixed" && (
        <EvtSelect
          isLoading={isLoading}
          data={data}
          placeholder="Select a Billable"
          className="min-w-60"
          value={filters?.billableId}
          onChange={(value) => setFilters({ ...filters, billableId: value })}
        />
      )}
      <TooltipInfo
        info="We have calculated the revenue for the jobs which has start date after 1st April 2025" /> */}
    </div>
  );
};

export default BudgetFilters;
